<template>
    <div class="formfield">
        <label
            v-if="label"
            class="formfield__label">
            {{ label }}
            <span
                class="required"
                v-if="required">*</span>
        </label>
        <ul class="inputlist">
            <li
                v-for="(option, index) in options"
                :key="index"
                :index="index">
                <div class="formfield">
                    <label 
                        class="formfield__choice" 
                        :class="{'formfield__choice--error': (error)}">
                        <input
                            type="radio"
                            :name="name"
                            v-model="currentChecked"
                            :value="option.value"
                            @change="removeError()">
                        <span>
                            {{ option.name }}
                        </span>
                    </label>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: '',
        },
        errors: {
            type: Object,
            default: null
        },
        options: {
            type: Array,
            default() {
                return [];
            }
        },
        required: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: '',
        },
        inputValue: {
            type: String,
            default: null,
        },
    },
    watch: {
        currentChecked() {
            this.$emit('input', this.currentChecked);
        }
    },
    data() {
        return {
            currentChecked: this.inputValue
        };
    },
    computed: {
        error() {
            if(this.errors) {
                return this.errors.first(this.name);
            }

            return '';
        },
    },
    methods: {
        removeError() {
            if(this.errors) {
                this.errors.remove(this.name);
            }
        }
    },
};
</script>
